import app from '@/firebase'
import { getDatabase, onValue, ref } from 'firebase/database'
import { useEffect, useState } from 'react'

export type CaseSyncStatus = 'syncing' | 'done' | 'error'
export type CaseSyncValue = { status: CaseSyncStatus; updatedAt: number } | null

// Subscribes to the backend sync status for a single case (written by runCaseMatch
// to RTDB under bilplus-admin/caseSync/{id}) and returns the latest raw value.
// Completion logic (comparing against a click-time baseline) lives in the caller,
// so a value replayed on subscribe is never mistaken for a fresh result.
export const useCaseSyncListener = (id?: string) => {
  const [value, setValue] = useState<CaseSyncValue>(null)

  useEffect(() => {
    if (!id) return

    const db = getDatabase(app)
    const syncRef = ref(db, `bilplus-admin/caseSync/${id}`)

    return onValue(
      syncRef,
      snapshot => setValue(snapshot.val()),
      error => console.error('caseSync listener error (check RTDB read rules):', error),
    )
  }, [id])

  return value
}
